import { SORT_BY_TEXTS, SEARCH_SORT_BY_OPTIONS } from '@/features/shared/constants/global'
import { useIsBrowse } from '@/features/shop/services/Search/hooks'
import { useIsPage } from '@/features/shared/hooks/useIsPage'

export const useGetSortByOptions = () => {
  const isBrowse = useIsBrowse()
  const isBuyAgainPage = useIsPage().BUY_AGAIN
  const { BEST_MATCH, MOST_FREQUENT, MOST_POPULAR } = SORT_BY_TEXTS

  let defaultOption = ''
  if (isBuyAgainPage) defaultOption = MOST_FREQUENT
  else defaultOption = isBrowse ? MOST_POPULAR : BEST_MATCH

  const sortByOptions = {
    [defaultOption]: defaultOption,
    ...SEARCH_SORT_BY_OPTIONS,
  }

  return { defaultOption, sortByOptions }
}
